export enum FileExtension {
  // Documents
  PDF = 'pdf',
  DOC = 'doc',
  DOCX = 'docx',
  XLS = 'xls',
  XLSX = 'xlsx',
  ODS = 'ods',
  PPT = 'ppt',
  PPTX = 'pptx',
  ODP = 'odp',
  ODT = 'odt',
  RTF = 'rtf',
  TXT = 'txt',
  CSV = 'csv',
  MD = 'md',
  LOG = 'log',

  // Images
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  GIF = 'gif',
  BMP = 'bmp',
  SVG = 'svg',
  WEBP = 'webp',
  TIF = 'tif',
  TIFF = 'tiff',
  ICO = 'ico',
  HEIC = 'heic',
  RAW = 'raw',
  PSD = 'psd',

  // Videos
  MP4 = 'mp4',
  MOV = 'mov',
  AVI = 'avi',
  WMV = 'wmv',
  FLV = 'flv',
  MKV = 'mkv',
  WEBM = 'webm',
  M4V = 'm4v',
  MPG = 'mpg',
  MPEG = 'mpeg',
  GP3 = '3gp',

  // Audio
  MP3 = 'mp3',
  WAV = 'wav',
  AAC = 'aac',
  OGG = 'ogg',
  FLAC = 'flac',
  M4A = 'm4a',
  WMA = 'wma',
  AMR = 'amr',

  // Archives
  ZIP = 'zip',
  RAR = 'rar',
  TAR = 'tar',
  GZ = 'gz',
  _7Z = '7z',
  ISO = 'iso',
  CAB = 'cab',

  // Code / markup
  HTML = 'html',
  HTM = 'htm',
  JS = 'js',
  JSON = 'json',
  XML = 'xml',
  YAML = 'yaml',
  YML = 'yml',

  // Design
  AI = 'ai',
  EPS = 'eps',
  INDD = 'indd',
  DWG = 'dwg',
  DXF = 'dxf',
}

export enum FileType {
  IMAGE = 'image',
  PDF = 'pdf',
  VIDEO = 'video',
  AUDIO = 'audio',
  EXCEL = 'excel',
  PPT = 'ppt',
  CSV = 'csv',
  TEXT = 'text',
  WORD = 'word',
  ZIP = 'zip',
  CODE = 'code',
  DESIGN = 'design',
  DEFAULT = 'default',
}
